import api from "APP_ROOT/api";
import { actionFactory } from "@orange-marmalade/paginate-this";
import { SUCCESS } from "LIB/submission/constants";
import { show } from "MODULES/parts/actions/actions";

export const partsApplicationsActions = actionFactory("part/applications");

export function createApplication(partId, type, data) {
  return dispatch =>
    api.parts.applications
      .of(type)
      .create(partId, data)
      .then(() => {
        dispatch(partsApplicationsActions.expire());
        dispatch(show(partId));
        return SUCCESS;
      });
}

export function searchApplicables(type, part) {
  return filter => () =>
    api.parts.applications
      .of(type)
      .applicables(filter)
      .then(resp => resp.data.results.filter(r => r.id !== part.id));
}

export function deleteApplication(id, partId) {
  return dispatch =>
    api.applications.delete(id).then(() => {
      dispatch(show(partId));
      return dispatch(partsApplicationsActions.expire());
    });
}



// WEBPACK FOOTER //
// ./app/modules/parts/actions/applications.js